/**
 * AudioContent - 音频内容渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';

export default function AudioContent({ data }) {
  if (!data || !data.audio) return null;

  const audioUrl = typeof data.audio === 'string' ? data.audio : data.audio.url;
  // 使用代理URL避免CORS问题
  const proxyAudioUrl = getProxyUrl(audioUrl);
  const ps = data.playerStyle || {};

  return (
    <div className="label-content-audio">
      <audio 
        src={proxyAudioUrl} 
        className="audio-player" 
        controls={(data.audioOptions ? data.audioOptions.controls !== false : true)}
        autoPlay={!!(data.audioOptions && data.audioOptions.autoplay)}
        loop={!!(data.audioOptions && data.audioOptions.loop)}
        style={{
          borderRadius: ps.radius ? ps.radius : 0,
          border: ps.borderWidth ? `${ps.borderWidth}px solid ${ps.borderColor || '#e8eaed'}` : 'none'
        }}
        onError={(e) => {
          console.error('音频加载失败:', audioUrl);
        }}
      />
    </div>
  );
}
